import { defineStore } from 'pinia'
import { twoFactorStore } from '../two-factor-store/twoFactor'
import {
  createLogbookEntry,
  getUserAndAccountData,
  userLogin,
  validateEmail
} from '../../services/auth'
import { appOptionsStore } from '../app-options-store/appOptionsStore'
import { getMyPermissions, userIsAdmin } from '../../services/account'
import { permissionsUserStore } from '../permissions-store/permissions'

const getRoutesFromUser = (backEndPermissions) => {
  // backEndPermissions['sanfer'] = [{"name": "Archivos Base", "code": "archivos_base"}]
  let finalRoutes = new Set()

  Object.entries(backEndPermissions).forEach(([module, permissions]) => {
    permissions.forEach(permission => {
      finalRoutes.add(permission.code)
    })
  })

  return finalRoutes
}

export const sessionUserStore = defineStore('session', {
  state: () => ({
    authToken: null,
    userData: null,
    currentRfc: '',
  }),
  getters: {
    getUserData: (state) => state.userData,
    getCurrentRFC: (state) => state.currentRfc,
    getIsLoggedIn: (state) => (state.userData !== null && state.authToken !== null),
    getAllRfcs: (state) => {
      if (!state.userData) return []
      return state.userData?.rfcs
    },
    getAuthToken: (state) => state.authToken,
    getSubscriptionSettingLimitConfig: (state) => (setting) => {
      let currentRfcInfo = state.userData?.account?.rfcs?.find(item => item.rfc == state.currentRfc)
      let configLimitSettings = currentRfcInfo?.subscription?.type?.settings?.find(item => item.type == setting)
      return configLimitSettings?.limit_config ?? null
    },
    getCurrentRFCData: (state) => {
      if (!state.userData) return null
      return state.userData?.account?.rfcs?.find(item => item.rfc == state.currentRfc)
    },
    getHasSubscriptionSetting: (state) => (setting) => {
      let currentRfcInfo = state.userData?.account?.rfcs?.find(item => item.rfc == state.currentRfc)
      let configLimitSettings = currentRfcInfo?.subscription?.type?.settings?.find(item => item.type == setting)
      if (configLimitSettings) return true
      return false
    },
    getSubscriptionSettingRateData: (state) => (setting) => {
      let currentRfcInfo = state.userData?.account?.rfcs?.find(item => item.rfc == state.currentRfc)
      let configRateStatesSettings = currentRfcInfo?.rate_states?.find(item => item?.setting_type?.type == setting)
      if (!configRateStatesSettings) return null
      return configRateStatesSettings
    },
  },
  actions: {

    async validateEmail(emailToken) {
      const storeAppOptions = appOptionsStore()
      let flag = false
      try {
        await validateEmail(emailToken)
        flag = true
      } catch (error) {
        flag = false
        storeAppOptions.setAlert({
          flag: true,
          title: 'Error de Usuario',
          snack: 'Ocurrió un error al validar tu correo.',
          type: 'error',
        })
      }
      return flag
    },

    async logIn({ username, email, password, ipAddr }) {
      const storeTwoFactor = twoFactorStore()
      const storeAppOptions = appOptionsStore()
      // Estado Inicial
      this.authToken = null
      storeTwoFactor.setEnable2fa(false)
      storeTwoFactor.setToken2fa('')

      try {
        const loginResponse = await userLogin(username, email, password, ipAddr)
        this.authToken = loginResponse?.data?.token
        storeTwoFactor.setEnable2fa(loginResponse.data?.user?.is_2fa_enabled)
        if (loginResponse.data?.user?.is_2fa_enabled) {
          storeTwoFactor.setToken2fa(loginResponse.data?.token_2fa)
        }
      } catch (error) {
        storeAppOptions.setAlert({
          flag: true,
          title: 'Error de Usuario',
          snack: '¡Atención!, sus credenciales no son validas. El usuario o contraseña son erróneos.',
          type: 'error',
        })
      }

    },

    async myAccountInfo() {
      const storeAppOptions = appOptionsStore()
      // Obtener la información del Usuario
      try {
        const responseUserInfo = await getUserAndAccountData(this.authToken)
        let usrData = responseUserInfo?.data;
        usrData.rfcs = usrData.rfcs.sort((a, b) => a.id - b.id);
        this.userData = usrData;
        this.currentRfc = usrData.rfcs[0]?.rfc
      } catch (e) {
        storeAppOptions.setLoginError('is_my_user_info_error')
        return
      }
    },

    async myPermissionsInfo() {
      const storePermissions = permissionsUserStore()
      const storeAppOptions = appOptionsStore()

      try{
        await createLogbookEntry({
          action_name: 'LOGIN',
          email: this.userData?.email
        });
      }catch (e) {
        console.log("Error en la bitacora");
      }

      try {
        const responseUserPermissions = await getMyPermissions(this.userData?.email)
        if (Object.keys(responseUserPermissions.data.detail).length === 0) {
          storeAppOptions.setLoginError('is_my_permissions_error')
          return
        } else {
          let permissions = getRoutesFromUser(responseUserPermissions.data.detail)
          storePermissions.setOptionsUser(responseUserPermissions.data.detail)
          storePermissions.setRoleType(responseUserPermissions.data.role)
          storePermissions.setCodeTypeRole(responseUserPermissions.data.roleCodeName)
          storePermissions.setPermissions([...permissions])
        }
      } catch (e) {
        storeAppOptions.setLoginError('is_my_permissions_error')
        return
      }
    },

    async myInfoAdmin() {
      const storePermissions = permissionsUserStore()
      const storeAppOptions = appOptionsStore()
      try {
        const responseAdmin = await userIsAdmin(this.userData?.email)
        if (responseAdmin.data?.isAdmin) {
          storePermissions.setIsAdmin(true)
        } else {
          storePermissions.setIsAdmin(false)
        }
      } catch (e) {
        storeAppOptions.setLoginError('is_my_info_admin_error')
        return
      }
    },

    selectCurrentRFC(payload) {
      let foundObject = this.userData?.rfcs.find(item => item.rfc === payload)
      this.currentRfc = foundObject.rfc
    },

  },
  persist: {
    storage: sessionStorage,
  },
})
